<template>

  <v-bottom-navigation >

    <a href="#/">

      <v-btn v-bind:class="{'v-btn--active': active==='0'}">
        <span>Inicio</span>

        <v-icon>mdi-home</v-icon>
      </v-btn>
    </a>

    <a href="#/colmenares">
      <v-btn v-bind:class="{'v-btn--active': active==='1'}">
        <span>Colmenares</span>
        <v-icon>mdi-beehive-outline</v-icon>
      </v-btn>
    </a>

    <a href="#/queens">
      <v-btn v-bind:class="{'v-btn--active': active==='2'}">

        <span>Reinas</span>

        <v-icon color="">mdi-crown-outline</v-icon>

      </v-btn>
    </a>

    <a href="#/tareas">
      <v-btn v-bind:class="{'v-btn--active': active==='3'}">
        <span>Tareas</span>
        <v-badge v-if="tareas>0"
                color="error"
                :content="tareas"
                overlap
        >
        <v-icon>mdi-calendar</v-icon>
        </v-badge>
        <v-icon v-else>mdi-calendar</v-icon>
      </v-btn>
    </a>

    <a href="#/colmenas-mini">
      <v-btn v-bind:class="{'v-btn--active': active==='4'}">

        <span>Minis</span>

        <v-badge v-if="minis>0"
                 color="error"
                 :content="minis"
                 overlap
        >
          <v-icon>mdi-archive-outline</v-icon>
        </v-badge>
        <v-icon v-else>mdi-archive-outline</v-icon>


      </v-btn>
    </a>


  </v-bottom-navigation>

</template>

<script>

import axios from "axios";
export default {
  name: 'menu-bottom',
  props: ['active'],
  data() {
        return {
          tareas:null,
          minis:null,
        }
  },
  created() {
    this.getTodos();
  },
  methods:{

      async getTodos(){

          var that = this

           await axios.get("https://appws.panimiel.com/new/index.php/api/task/count_open_tasks").then((tareas) => {
            that.tareas = tareas.data
          })

           await axios.get("https://appws.panimiel.com/new/index.php/api/hive_mini/count_minis").then((minis) => {
            that.minis = minis.data
          })

      }
  }


}
</script>